<template>
	<PCard class="my-3">
		<template #title>
			<div class="flex align-items-center justify-content-between">
				<WSubTitle text="Net Electrical Energy Actual Exp" />
			</div>
		</template>
		<template #content>
			<div class="flex flex-row flex-wrap justify-content-start align-items-center mt-2 mb-3">
				<PFloatLabel>
					<PCalendar
						:manualInput="false"
						:showOnFocus="true"
						class="mx-2"
						hourFormat="24"
						iconDisplay="input"
						inputId="energyDateFrom"
						showIcon
						style="width: 230px"
						showTime
						v-model="energyDateFrom"
						@date-select="changeEnergyFrom"
					/>
					<label
						class="ml-1 font-bold"
						for="energyDateFrom"
					>From</label>
				</PFloatLabel>
				<PFloatLabel>
					<PCalendar
						:manualInput="false"
						:showOnFocus="true"
						class="mx-2"
						hourFormat="24"
						iconDisplay="input"
						inputId="energyDateTo"
						showIcon
						style="width: 230px"
						showTime
						v-model="energyDateTo"
						@date-select="changeEnergyTo"
					/>
					<label
						class="ml-1 font-bold"
						for="energyDateTo"
					>To</label>
				</PFloatLabel>
			</div>

			<div id="chart">
				<apexchart
					type="area"
					height="350"
					:options="chartOptions"
					:series="series"
				></apexchart>
			</div>
		</template>
	</PCard>
</template>

<script>
import {defineComponent, Events} from 'vue'
export default defineComponent({
	props: ['title'],
	data() {
		return {
			NEEIData: [],
			PNOMData: [],
			PNOMIData: [],
			energyDateFrom: '',
			energyDateTo: '',

			xMin: new Date('2024-06-7').getTime(),
			xMax: new Date('2024-06-29').getTime(),
		}
	},
	computed: {
		series() {
			return [
				{
					name: 'NEEI',
					data: this.NEEIData,
				},
				{
					name: 'PNOMI',
					data: this.PNOMIData,
				},
				{
					name: 'PNOM',
					data: this.PNOMData,
				},
			]
		},
		chartOptions() {
			return {
				chart: {
					type: 'area',
					stacked: false,
					height: 350,
					zoom: {
						type: 'x',
						enabled: true,
						autoScaleYaxis: false,
					},
					toolbar: {
						autoSelected: 'zoom',
					},
				},
				dataLabels: {
					enabled: false,
				},
				markers: {
					size: 0,
				},
				fill: {
					type: 'gradient',
					gradient: {
						shadeIntensity: 1,
						inverseColors: false,
						opacityFrom: 0.5,
						opacityTo: 0,
						stops: [0, 90, 100],
					},
				},
				yaxis: {
					title: {
						text: 'Price',
					},
				},
				xaxis: {
					type: 'datetime',
					min: this.xMin,
					max: this.xMax,
				},
				tooltip: {
					shared: false,
				},
			}
		},
	},
	mounted() {
		const NEEI = require('@/assets/invoiceData/NEEI.json')
		const PNOMI = require('@/assets/invoiceData/PNOMI.json')
		const PNOM = require('@/assets/invoiceData/PNOM.json')
		// console.log(NEEI);
		for (const date of NEEI) {
			this.NEEIData.push({
				x: new Date(date.x).getTime(),
				y: date.y,
			})
		}
		for (const date of PNOMI) {
			this.PNOMIData.push({
				x: new Date(date.x).getTime(),
				y: date.y,
			})
		}
		for (const date of PNOM) {
			this.PNOMData.push({
				x: new Date(date.x).getTime(),
				y: date.y,
			})
		}

		// console.log(this.NEEIData);
	},
	methods: {
		changeEnergyFrom() {
			this.xMin = new Date(this.energyDateFrom).getTime()
		},
		changeEnergyTo() {
			this.xMax = new Date(this.energyDateTo).getTime()
		},
	},

	watch: {},
})
</script>